export default __webpack_public_path__ + "static/media/dark-bg-kahsh-labs-mobile.2791956e.png";